import * as React from 'react'
import { useDispatch } from 'react-redux'
import { Box, useTheme } from '@mui/material'
import { ItemTypeMappings } from '../../types'
import { setSelectedQuestion } from '../../../../store/slices/SurveyTemplateSlice'
import { ButtonType } from '../../../../components/GenericButton/styles'
import Dropdown from '../../../../components/Dropdown'
import AddIcon from '@mui/icons-material/Add'

interface SurveyItemDropdownProps {
  sectionNumber: number
  isCountComplete?: boolean
  isQuestionAllowed?: boolean
}

const SurveyItemDropdown: React.FC<SurveyItemDropdownProps> = ({ sectionNumber, isCountComplete, isQuestionAllowed }): JSX.Element => {
  const dispatch = useDispatch()
  const theme = useTheme()

  const handleMenuItemClick = (item: string): void => {
    const selectedValue = ItemTypeMappings[item]
    dispatch(setSelectedQuestion({ sectionIndex: sectionNumber, questionType: selectedValue }))
  }

  const itemKeys = Object.keys(ItemTypeMappings)

  const menuItems = itemKeys.map(item => ({
    text: item,
    action: () => { handleMenuItemClick(item) }
  }))

  return (
    <Box display='flex' justifyContent='center' mt={theme.spacing(6)}>
        <Dropdown
          label="Add Question"
          extraButtonProps={{
            startIcon: <AddIcon />,
            endIcon: null
          }}
          menuItems={menuItems}
          buttonType={ButtonType.Primary}
          disabled={isCountComplete}
        />
    </Box>
  )
}

export default SurveyItemDropdown
